export default {
  active: state => state.active,
  searchactive: state => state.searchactive,
  languagesactive: state => state.languagesactive,
  animating: state => state.animating,
  searchanimating: state => state.searchanimating,
  languagesanimating: state => state.languagesanimating
}



// WEBPACK FOOTER //
// ./assets/js/store/modules/sidebar/getters.js